import { createContext } from 'react';
import { ILookupContext } from './types';

export const ISNILookupContext = createContext<ILookupContext>({} as ILookupContext);
